

import {useAxios} from './';

const useMovimentacoes = () => {
    const {getApiEmitirNotas} = useAxios();

    

    const getOrigemMovimentacao = async (movimentacao) => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/movimentacao-estoque/' + movimentacao.id + "/origem");
        return result.data;
    }


    return {getOrigemMovimentacao};
}




export {useMovimentacoes}